import {Component, OnInit} from '@angular/core';
import {FormGroup, Validators, FormBuilder } from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {DomainNameParserService} from 'src/main/resources/static/angular2/app/shared/services/domain-name-parser.service';
import {User} from '../../models/User.model';
import {AuthService} from "../../services/auth.service";
import {PHONE_NUMBER_LIST} from "../../../shared/constants/phone-numbers.const";
import {error} from "protractor";

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css',
  './../../../../assets/css/floating-labels.css'
  ]
})
export class LoginFormComponent implements OnInit {

  signInForm: FormGroup;
  submitted: boolean = false;
  rememberMe: boolean = false;
  showErrMsg: boolean = false;
  showEmailErrMsg: boolean = false;
  showAuthFailErrMsg: boolean = false;
  showAuthWarnErrMsg: boolean = false;
  showAccountRevokedErrMsg: boolean = false;
  showAccountLockedErrMsg: boolean = false;
  showNotFoundErrMsg: boolean = false;
  errorAlertOpen: boolean = false;
  goToParam: string;
  customerServicePhone: string;

  constructor(fb: FormBuilder,
              private authService: AuthService,
              private route: ActivatedRoute,
              private domainNameParserService: DomainNameParserService) {

    this.signInForm = fb.group({
      signInUsername: [null, Validators.required],
      signInPassword: [null, Validators.required],
      rememberMe: [false]
    });

    this.customerServicePhone = PHONE_NUMBER_LIST[this.domainNameParserService.getState()];
   }

  get signInUsername() {
    return this.signInForm.get('signInUsername');
  }

  get signInPassword() {
    return this.signInForm.get('signInPassword');
  }

  ngOnInit(): void {

  }

  submitSignInForm(): void {
    if(this.signInForm.invalid) {
        return;
    }

    console.log(this.signInForm.value);

    const data: User = this.signInForm.value as User;
    this.authService.authenticate(data).subscribe({
      next: x => {
        console.log('User authenticated');
        this.showErrMsg = false;

        this.findUrlParams();

        if(this.goToParam == null || this.goToParam == undefined) {
          console.error('No goto query parameter.');
        } else {
          console.log(`goTo: ${this.goToParam}`);
          this.navigateToGotoUrl();
        }
      },
      error: err => {
        console.error(`User not authenticated with error: ${err.error.code} (${err.error.reason}): ${err.error.message}`);
        this.errorMethod(JSON.parse(err.error.message).code, JSON.parse(err.error.message).message);
      }
    });

    this.submitted = true;
  }

  resetSignInForm() {
    this.submitted = false;
    this.signInForm.reset();
  }

  navigateToGotoUrl(): void {
    document.location.href = this.goToParam;
  }

  findUrlParams(): void {
    this.route.queryParamMap.subscribe(params => {
	  this.goToParam = "/#!/auth/dashboard";
      console.log(`goTo: ${this.goToParam}`);
    })
  }

  errorMethod(code: Number, message: String): void {
    if(code == 401) {
      if(message == 'Authentication Failed') {
        this.showAuthFailMessage();
      } else if(message == 'Your account has been revoked.') {
        this.showAccountRevokedMessage();
      } else if(message == 'Your account has been locked.') {
        this.showAccountLockedMessage();
      } else if(message == 'Authentication Failed Warning: You will be locked out after 2 more failure(s).' 
                || message == 'Authentication Failed Warning: You will be locked out after 1 more failure(s).') {
        this.showAuthWarnMessage();
      } else if(message == 'Email not verified.') {
        this.showEmailErrorMessage();
      } else {
        this.showNotFoundMessage();
      }
    } else if(code == 404 || (code >= 500 && code <= 599)) {
      this.showNotFoundMessage();
    } else {
      this.showNotFoundMessage();
    }
    
  }

  private showEmailErrorMessage(): void {
    this.resetErrorsShown();
    this.showEmailErrMsg = true;
    this.errorAlertOpen = true;
  }

  private showAuthFailMessage(): void {
    this.resetErrorsShown();
    this.showAuthFailErrMsg = true;
    this.errorAlertOpen = true;
  }

  private showAuthWarnMessage(): void {
    this.resetErrorsShown();
    this.showAuthWarnErrMsg = true;
    this.errorAlertOpen = true;
  }

  private showAccountRevokedMessage(): void {
    this.resetErrorsShown();
    this.showAccountRevokedErrMsg = true;
    this.errorAlertOpen = true;
  }

  private showAccountLockedMessage(): void {
    this.resetErrorsShown();
    this.showAccountLockedErrMsg = true;
    this.errorAlertOpen = true;
  }

  private showNotFoundMessage(): void {
    this.resetErrorsShown();
    this.showNotFoundErrMsg = true;
    this.errorAlertOpen = true;
  }

  private resetErrorsShown(): void {
    this.errorAlertOpen = false;
    this.showEmailErrMsg = false;
    this.showAuthWarnErrMsg = false;
    this.showAuthFailErrMsg = false;
    this.showAccountLockedErrMsg = false;
    this.showAccountRevokedErrMsg = false;
    this.showNotFoundErrMsg = false;
  }
}
